import {useAppDispatch} from '../../hooks/redux'
import {closeModal} from '../../redux/features/modal'

import {ModalMeta} from '../../types'

import Button from '../../../../commons/src/components/button'
import Headline from '../../../../commons/src/components/headline'
import Modal from '../../../../commons/src/components/modal'
import Paragraph from '../../../../commons/src/components/paragraph'

type Props = {
  meta: ModalMeta
  enable: boolean
  onConfirm: () => void
}

const ConfirmToggleAvailabilityModal = ({meta, enable, onConfirm}: Props) => {
  const dispatch = useAppDispatch()

  return (
    <Modal
      fullscreenMobile={meta.fullscreenMobile}
      headline={<Headline label={`Please confirm ${enable ? 'enabling' : 'disabling'}`} size="l" />}
      onClose={() => dispatch(closeModal())}
      buttons={
        <>
          <Button hierarchy="ghost" onClick={() => dispatch(closeModal())}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              onConfirm()
              dispatch(closeModal())
            }}
          >
            {enable ? 'Enable' : 'Disable'}
          </Button>
        </>
      }
    >
      <Paragraph>
        Are you sure you would like to {enable ? 'enable' : 'disable'} your selection?
        <br />
        The selection will {!enable && 'not'} be visible on Craftcloud.
      </Paragraph>
    </Modal>
  )
}

export default ConfirmToggleAvailabilityModal
